export default function React_useReducer() {
  return (
    <div>
      <h1>React_useReducer Component</h1>
      <p>This is the React_useReducer tutorial page.</p>
    </div>
  );
}
